module.exports = __webpack_public_path__ + "img/banner.d5da59a0.jpg";